import { call, takeEvery, put, select, delay, all } from 'redux-saga/effects';
import * as requestsActions from '../actions/requests';
import {
  // getAllRequestsRequest,
  filterRequestsRequest,
  createRequestRequest,
  getRequestRequest,
  updateRequestRequest,
  deleteRequestRequest,
  getRequestsByProfile,
  // searchRequestRequest,
  getActualClients,
  getFilterRequestRequest,
  getCountsRequest
} from '../../api/requests';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import history from '../../../../../common/history';
import { setViewLogRequest } from '../../../../../common/api/viewLog/setViewLogRequest';
import { deleteViewLogRequest } from '../../../../../common/api/viewLog/deletViewLogRequest';
import { getAllVehiclesRequest } from '../../../../Transport/api/vehicles/vehicles';
import { getDriversRequest } from '../../../../Employees/api/drivers/getDriversRequest';
import {
  failureOfferVehicles,
  failureOfferDrivers,
  failureOfferDriversAndTS,
} from '../../components/RequestCard/common/modal/failureModal/FailureModal';
import showFailureModal from '../../../../../common/components/failureModal/failureModal';
import showSuccessWindow from '../../../../../common/components/successPopup/successPopup';

const getAllRequests = state => {
  return (
    state.Executorship &&
    state.Executorship.Requests &&
    state.Executorship.Requests.requests.allRequests
  );
};

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllRequestsSaga() {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getFilterRequestRequest, activeProfileId, {type: 'all'});
      const requestCounts = yield call(getCountsRequest, activeProfileId);
      let requestTypes = {};
      let watchedTypes = {};
      let repliedTypes = {};
      let drivers = [];
      let watched = 0;
      let unwatched = 0;
      let watchedStat = {};
      // Разбиваем данные по типу, просмотру и ответу
      for (let key in requestCounts) {
        if ( key === 'direct' || key === 'free' || key === 'all') {
          requestTypes[key] = {
            type: key,
            name: requestCounts[key].type,
            count: requestCounts[key].count
          }
        }
        if (key === 'watched' || key === 'unwatched') {
          watchedTypes[key] = {
            type: key,
            name: requestCounts[key].type,
            count: requestCounts[key].count
          }
        }
        if (key === 'replied' || key === 'notReplied') {
          repliedTypes[key] = {
            type: key,
            name: requestCounts[key].type,
            count: requestCounts[key].count
          }
        }
      }
      response.data.forEach(item => {
        if (item.watched) {
          watched++;
        } else {
          unwatched++;
        }
      });
      watchedStat.watched = watched;
      watchedStat.unwatched = unwatched;
      yield put(
        requestsActions.getAllRequestsSuccess({
          requestTypes: Object.keys(requestTypes).map(key => requestTypes[key]),
          watchedTypes: Object.keys(watchedTypes).map(key => watchedTypes[key]),
          repliedTypes: Object.keys(repliedTypes).map(key => repliedTypes[key]),
          requests: response.data,
          pagination: response.pagination,
          drivers,
          watchedStat,
        })
      );
    } catch (e) {
      yield put(requestsActions.getAllRequestsError(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(requestsActions.getAllRequests())
      : history.push('/authorization/profiles');
  }
}

function* getFilterRequestsSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getFilterRequestRequest,
        activeProfileId,
        action.payload
      );
      let drivers = [];
      response.data.forEach(item => {
        // собираем всех водителей и исключаем дубликаты
        if (item.driver && item.driver.length > 0) {
          item.driver.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });

      yield put(
        requestsActions.getFilterRequestsSuccess({
          requests: response.data,
          pagination: response.pagination,
          drivers,
        })
      );
    } catch (err) {
      yield put(requestsActions.getFilterRequestsError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(requestsActions.getFilterRequests())
      : history.push('/authorization/profiles');
  }
}

function* getRequestsByProfileSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRequestsByProfile, payload);
    yield put(requestsActions.getRequestsByProfileSuccess(response));
  } catch (error) {
    yield put(requestsActions.getRequestsByProfileError(error));
  }
}

function* filterRequestsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(filterRequestsRequest, payload);
    yield put(requestsActions.filterRequestsSuccess(response));
  } catch (error) {
    yield put(requestsActions.filterRequestsError(error));
  }
}

function* createRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(createRequestRequest, payload);
    yield put(requestsActions.createRequestSuccess(response));
  } catch (error) {
    yield put(requestsActions.createRequestError(error));
  }
}

function* getRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRequestRequest, payload);
    yield put(requestsActions.getRequestSuccess(response));
  } catch (error) {
    yield put(requestsActions.getRequestError(error));
  }
}

function* updateRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(updateRequestRequest, payload);
    yield put(requestsActions.updateRequestSuccess(response));
  } catch (error) {
    yield put(requestsActions.updateRequestError(error));
  }
}

function* deleteRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(deleteRequestRequest, payload);
    yield put(requestsActions.deleteRequestSuccess(response));
  } catch (error) {
    yield put(requestsActions.deleteRequestError(error));
  }
}

function* watchRequestSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response =
        payload &&
        (yield all(
          payload.map(item =>
            call(setViewLogRequest, activeProfileId, item, 'request')
          )
        ));
      let allRequests = yield select(getAllRequests);
      response.map(
        (res, idx) =>
          res.data &&
          res.data.result &&
          allRequests.map(
            request => request.id === payload[idx] && (request.watched = true)
          )
      );
      let watchedStat = {};
      let watched = 0;
      let unwatched = 0;
      allRequests.forEach(item => {
        if (item.watched) {
          watched++;
        } else {
          unwatched++;
        }
      });
      watchedStat.watched = watched;
      watchedStat.unwatched = unwatched;
      yield put(
        requestsActions.watchRequestSuccess({
          requests: allRequests,
          watchedStat,
        })
      );
    } catch (e) {
      yield put(requestsActions.watchRequestFailure(errorProcessing(e)));
    }
  }
}

function* unwatchRequestSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response =
        payload &&
        (yield all(
          payload.map(item =>
            call(deleteViewLogRequest, activeProfileId, item, 'request')
          )
        ));
      let allRequests = yield select(getAllRequests);
      response.map(
        (res, idx) =>
          res.data &&
          res.data.result &&
          allRequests.map(
            request => request.id === payload[idx] && (request.watched = false)
          )
      );
      let watchedStat = {};
      let watched = 0;
      let unwatched = 0;
      allRequests.forEach(item => {
        if (item.watched) {
          watched++;
        } else {
          unwatched++;
        }
      });
      watchedStat.watched = watched;
      watchedStat.unwatched = unwatched;
      yield put(
        requestsActions.unwatchRequestSuccess({
          requests: allRequests,
          watchedStat,
        })
      );
    } catch (e) {
      yield put(requestsActions.unwatchRequestFailure(errorProcessing(e)));
    }
  }
}

// GET ACTUAL COMPANIES
function* getActualClientsSaga() {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const actualClients = yield call(getActualClients, activeProfileId);
      yield put(requestsActions.getActualClientsSuccess(actualClients));
    } catch (e) {
      yield put(requestsActions.getActualClientsError(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(requestsActions.getActualClients())
      : history.push('/authorization/profiles');
  }
}

function* checkCompanyVehiclesAndDriversSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const vehicles = yield call(getAllVehiclesRequest, activeProfileId);
      const drivers = yield call(getDriversRequest, activeProfileId);
      if (!drivers.length && !vehicles.length) {
        showSuccessWindow(failureOfferDriversAndTS());
      } else if (!vehicles.length) {
        showFailureModal(failureOfferVehicles());
      } else if (!drivers.length) {
        showSuccessWindow(failureOfferDrivers());
      } else {
        history.push({
          pathname: `/offer_create/`,
          state: { id: payload },
        });
      }
    } catch (e) {
      //err
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(
          requestsActions.checkCompanyVehiclesAndDrivers(action.payload)
        )
      : history.push('/authorization/profiles');
  }
}

export function* requestsWatcher() {
  // set view_log
  // yield takeEvery(requestsActions.setViewLogRequest.toString(), setViewLogSaga);
  yield takeEvery(
    requestsActions.getAllRequests.toString(),
    getAllRequestsSaga
  );
  yield takeEvery(
    requestsActions.getFilterRequests.toString(),
    getFilterRequestsSaga
  );
  yield takeEvery(
    requestsActions.getRequestsByProfile.toString(),
    getRequestsByProfileSaga
  );
  yield takeEvery(
    requestsActions.filterRequests.toString(),
    filterRequestsSaga
  );
  yield takeEvery(requestsActions.getRequest.toString(), getRequestSaga);
  yield takeEvery(requestsActions.updateRequest.toString(), updateRequestSaga);
  yield takeEvery(requestsActions.createRequest.toString(), createRequestSaga);
  yield takeEvery(requestsActions.deleteRequest.toString(), deleteRequestSaga);
  /*yield takeEvery(
    requestsActions.searchRequests.toString(),
    searchRequestsSaga
  );*/
  yield takeEvery(requestsActions.watchRequest.toString(), watchRequestSaga);
  yield takeEvery(
    requestsActions.unwatchRequest.toString(),
    unwatchRequestSaga
  );
  yield takeEvery(
    requestsActions.checkCompanyVehiclesAndDrivers.toString(),
    checkCompanyVehiclesAndDriversSaga
  );
  yield takeEvery(
    requestsActions.getActualClients.toString(),
    getActualClientsSaga
  );
}
